import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserDetailsType } from "../../types/genericType";

const initialUserState: UserDetailsType = {
  id: 0,
  firstName: "",
  lastName: "",
  email: "",
  role: "",
  isActive: false,
  accounts: [],
  statements: [],
};

interface UserState {
  selectedUser: UserDetailsType;
}

const initialState: UserState = {
  selectedUser: initialUserState,
};

export const userSlice = createSlice({
  name: "userState",
  initialState,
  reducers: {
    setSelectedUser: (state, action: PayloadAction<UserDetailsType>) => {
      state.selectedUser = action.payload;
    },
    resetSelectedUser: (state) => {
      state.selectedUser = initialUserState;
    },
  },
});

export const { setSelectedUser, resetSelectedUser } = userSlice.actions;

export default userSlice.reducer;
